<div class="modal-header">
  <p class="modal-title">
    <fa-icon [icon]="['fas', 'exchange-alt']" class="me-2" [fixedWidth]="true"></fa-icon>
    {{ 'group.transfer-modal-title' | translate }}
  </p>
</div>
<div #modalBody class="modal-body" (scroll)="checkScroll()">
  @if (isLoading) {
    <div class="modal-loading">
      <fa-icon [icon]="['fas', 'spinner']" animation="spin" class="loading-icon"></fa-icon>
    </div>
  }

  @if (!isLoading) {
    <p class="transfer-intro">{{ 'group.transfer-modal-subtitle' | translate }}</p>
    <div class="transfer-list-header">
      <p class="transfer-count">{{ transferSummaryKey | translate: { count: cases.length } }}</p>
      <div class="global-recipient-wrap">
        <label class="transfer-select-label">{{ 'group.transfer-global-recipient-label' | translate }}</label>
        <select class="form-control form-control-sm"
          [(ngModel)]="globalRecipient"
          (ngModelChange)="onGlobalRecipientChange()">
          <option value="">{{ 'group.transfer-keep-label' | translate }}</option>
          @for (member of members; track member) {
            <option [value]="member.userId">{{ member.fullName }}</option>
          }
        </select>
      </div>
    </div>
    <div class="transfer-case-list">
      @for (creditorCase of cases; track creditorCase) {
        <div class="transfer-case-card">
          <div class="case-info">
            <div class="case-header">
              <span class="case-name">{{ creditorCase.caseSummary.caseName }}</span>
              @if (creditorCase.requiresAttention) {
                <span class="badge text-bg-warning attention-badge">
                  <fa-icon [icon]="['fas', 'exclamation-triangle']" class="me-1"></fa-icon>
                  {{ 'group.transfer-requires-attention' | translate }}
                </span>
              }
            </div>
            @if (creditorCase.caseSummary.caseOrgNr) {
              <div class="case-orgnr">{{ creditorCase.caseSummary.caseOrgNr }}</div>
            }
            <div class="case-meta">
              @if (creditorCase.caseSummary.caseCourtName) {
                <span class="meta-item"
                  [title]="'label.court' | translate">
                  <fa-icon [icon]="['fas', 'gavel']" class="meta-icon"></fa-icon>
                  {{ creditorCase.caseSummary.caseCourtName }}@if (creditorCase.caseSummary.caseNumber) {
                  <span> · {{ creditorCase.caseSummary.caseNumber }}</span>
                }
              </span>
            }
            @if (creditorCase.caseSummary.caseDecisionDate) {
              <span class="meta-item"
                [title]="'label.bankruptcy-date' | translate">
                <fa-icon [icon]="['fas', 'calendar-alt']" class="meta-icon"></fa-icon>
                {{ creditorCase.caseSummary.caseDecisionDate | localizeddate:'yyyy-MM-dd' }}
              </span>
            }
            @if (creditorCase.caseSummary.trusteeName) {
              <span class="meta-item"
                [title]="'label.trustee' | translate">
                <fa-icon [icon]="['fas', 'user']" class="meta-icon"></fa-icon>
                {{ creditorCase.caseSummary.trusteeName }}
              </span>
            }
          </div>
          @if (claimsMap[creditorCase.id] !== undefined) {
            <div class="case-claims">
              @if (claimsMap[creditorCase.id].length === 0) {
                <div class="no-claims">
                  {{ 'group.transfer-no-claims' | translate }}
                </div>
              }
              @for (claim of getVisibleClaims(creditorCase.id); track claim) {
                <div class="claim-row" [class.claim-row--declined]="claim.isDeclined">
                  <span class="claim-type-badge"
                    [class.badge-pre-request]="claim.isPreRequest && !claim.isDeclined"
                    [class.badge-proof-of-debt]="!claim.isPreRequest && !claim.isDeclined"
                    [class.badge-declined]="claim.isDeclined">
                    @if (claim.isDeclined) {
                      <fa-icon [icon]="['fas','times-circle']" class="me-1"></fa-icon>
                    }
                    {{ getClaimLabel(claim) | translate }}
                  </span>
                  <span class="claim-amount">{{ claim.amount | number:'1.0-0' }} kr</span>
                </div>
              }
              @if (claimsMap[creditorCase.id].length > claimsPreviewCount) {
                <button
                  type="button"
                  class="claims-toggle-btn"
                  (click)="toggleClaims(creditorCase.id)">
                  <fa-icon [icon]="['fas', isClaimsExpanded(creditorCase.id) ? 'chevron-up' : 'chevron-down']" class="me-1"></fa-icon>
                  {{ (isClaimsExpanded(creditorCase.id) ? 'group.transfer-claims-show-less' : 'group.transfer-claims-show-more') | translate: { count: getHiddenClaimCount(creditorCase.id) } }}
                </button>
              }
            </div>
          }
        </div>
        <div class="case-transfer">
          <label class="transfer-select-label">{{ 'group.transfer-recipient-column' | translate }}</label>
          <select class="form-control form-control-sm"
            [(ngModel)]="transferSelections[creditorCase.caseSummary.caseId]">
            <option value="">{{ 'group.transfer-keep-label' | translate }}</option>
            @for (member of members; track member) {
              <option [value]="member.userId">{{ member.fullName }}</option>
            }
          </select>
        </div>
      </div>
    }
  </div>
}
</div>
<div class="modal-footer">
  @if (!isLoading) {
    <button type="button" class="btn btn-primary btn-modal" (click)="confirmAndLeave()">
      <fa-icon [icon]="['fas', 'sign-out-alt']" class="me-1"></fa-icon>
      {{ 'group.transfer-confirm-button' | translate }}
    </button>
    <button type="button" class="btn btn-warning btn-modal" (click)="leaveWithoutTransfer()">
      {{ 'group.transfer-skip-button' | translate }}
    </button>
  }
  <button type="button" class="btn btn-secondary btn-modal" (click)="cancel()">
    {{ 'button.avbryt' | translate }}
  </button>
  @if (isScrollable) {
    <button type="button" class="modal-scroll-btn" (click)="scrollToggle()">
      <fa-icon [icon]="['fas', isAtBottom ? 'arrow-circle-up' : 'arrow-circle-down']" style="color: #fff; width: 100%; height: 100%; filter: drop-shadow(0 3px 6px rgba(0, 0, 0, .4))"></fa-icon>
    </button>
  }
</div>
